export namespace Intuitive {
  export const companyIds = ['54d0016c-1318-4411-b8f4-f6b66bef0e4f', 'a9cf7cf7-4bad-4bb2-a77b-f625ca24a0c0'];
}
